import { RootState } from "../../Store";

function reducedCo2(state: RootState) {
  const tradCo2 = state.cfpTable.tableData[0].traditional;
  const multicoteCo2 = state.cfpTable.tableData[0].multicoteTechnology;

  return (tradCo2 ?? 0) - (multicoteCo2 ?? 0);
}

const CFPTabelSelectors = {
  reducedCo2,
};

export default CFPTabelSelectors;
